import React, { useState, useEffect } from 'react';
import Alert from '@material-ui/lab/Alert';
import { useLocation } from "react-router-dom";

import { ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';

import TulipThemes from '../Themes';
import { IncidentTrackerApi } from '../apis';
import { MonitorList } from '../components';

function SLAPage() {
  const [isLoading, setLoading] = useState(true);
  const [monitors, setMonitors] = useState({});
  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token');

  const asyncFetch = async () => {
    setLoading(true);
    let res;

    try {
      if (process.env.REACT_APP_ROUTING_ENV === 'external') {
        res = await IncidentTrackerApi.getMonitorsByToken(token);
      } else {
        res = await IncidentTrackerApi.getMonitors();
      }
      console.log(res.monitors);
      setMonitors({ monitors: res.monitors });
    } catch(e) {
      console.log(e)
      setMonitors({ monitors: [], error: e.message })
    }

    setLoading(false);
  };

  useEffect(() => { asyncFetch() }, [token]);

  return (
    <ThemeProvider theme={TulipThemes.defaultTheme}>
      <Container maxWidth="lg">
        {
          monitors.error &&
          <Box marginTop={5}>
            <Alert severity="error">{monitors.error}</Alert>
          </Box>
        }
        <Box marginTop={5}>
          <Typography variant="h4" component="h1">
            Uptime
          </Typography>
        </Box>
        <Box marginTop={5}>
          {
            (!isLoading && <MonitorList monitors={monitors.monitors} />) || <CircularProgress />
          }
        </Box>
      </Container>
    </ThemeProvider>
  )
}

export default SLAPage;
